import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import InsightMenu from '../components/content/InsightMenu.vue';
import InsightList from '../components/content/InsightList.vue';
import { useRoute } from 'vue-router';
import CategoryInsightList from '@/components/content/CategoryInsightList.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'InsightView',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(InsightMenu),
    (_unref(route).path === '/insight')
      ? (_openBlock(), _createBlock(InsightList, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(route).path === '/insight')
      ? (_openBlock(), _createBlock(CategoryInsightList, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})